import CustomerPortalWrapper from "@/views/Customer/CustomerPortalWrapper.vue";
import EmptyRouterView from "@/views/EmptyRouterView.vue";

import FrontPage from "@/views/Customer/FrontPage.vue";

//machine
import MachineList from "@/views/Customer/Equipment/MachineList.vue";
/**/ //view machine
/**/ /**/ /**/ /**/ import PartDocumentDialog from "@/components/Dialogs/PartDocumentDialog.vue";
/**/ /**/ /**/ import PartInfoDialog from "@/components/Dialogs/PartInfoDialog.vue";
/**/ /**/ import FormsPanel from "@/views/Customer/Equipment/FormsPanel.vue";
/**/ /**/ import GeneralPanel from "@/views/Customer/Equipment/GeneralPanel.vue";
/**/ /**/ import ManualsPanel from "@/views/Customer/Equipment/ManualsPanel.vue";
/**/ /**/ import PartDocumentPanel from "@/views/Customer/Equipment/PartDocumentPanel.vue";
/**/ /**/ import PartsPanel from "@/views/Customer/Equipment/PartsPanel.vue";
/**/ /**/ import ResourcesPanel from "@/views/Customer/Equipment/ResourcesPanel.vue";
/**/ /**/ import ServicePanel from "@/views/Customer/Equipment/ServicePanel.vue";
import ViewMachine from "@/views/Customer/Equipment/ViewMachineWrapper.vue";

//job
import JobList from "@/views/Customer/Orders/JobList.vue";

//shop
//TODO: Catalouge page
import Shop from "@/views/Customer/Shop/Shop.vue";
import ShoppingCart from "@/views/Customer/Shop/ShoppingCart.vue";

//more
import Organization from "@/views/Customer/Organization.vue";


const routes = {
  path: "/customer",
  name: "Customer",
  redirect: { name: 'FrontPage' },
  component: CustomerPortalWrapper,
  children: [

    {
      meta: {
        displayName: 'FrontPage',
      },
      name: "FrontPage",
      path: "-",
      redirect: { name: 'MachineList' },
      component: FrontPage,

    },

    //machines ------------------------------------------------------------
    {
      name: "Machines",
      path: "machines",
      redirect: { name: 'MachineList' },
      component: EmptyRouterView,
      children: [
        {
          meta: {
            displayNameKey: "text.equipment_list",
          },
          name: "MachineList",
          component: MachineList,
          path: "list",
        },
        {
          name: "ViewMachine",
          path: ":id",
          redirect: { name: 'GeneralPanel' },
          component: ViewMachine,
          children: [
            {
              name: "GeneralPanel",
              component: GeneralPanel,
              path: "general",
              props: true,
            },
            {
              name: "ServicePanel",
              component: ServicePanel,
              path: "service/:jobId?"
            },
            {
              name: "PartsPanel",
              component: PartsPanel,
              path: "parts",
              children: [
                {
                  name: "PartInfoDialog",
                  component: PartInfoDialog,
                  path: ":part",
                },
              ],
            },
            {
              name: "ResourcesPanel",
              component: ResourcesPanel,
              path: "resources",
            },
            {
              name: "ManualsPanel",
              component: ManualsPanel,
              path: "manuals",
            },
            {
              name: "FormsPanel",
              component: FormsPanel,
              path: "forms",
            },
            {
              name: "PartDocumentPanel",
              path: "partsdocuments",
              component: PartDocumentPanel,
              children: [
                {
                  name: "PartDocumentDialog",
                  component: PartDocumentDialog,
                  path: ":modelid/:documentid",
                },
              ],
            },
          ],
        },
      ]
    },

    //jobs ------------------------------------------------------------
    {
      meta: {
        displayNameKey: "text.orders",
      },
      path: "jobs/:jobId?",
      name: "JobList",
      component: JobList,
    },

    //shop ------------------------------------------------------------
    {
      meta: {
        displayNameKey: "text.shop",
      },
      name: "Shop",
      path: "shop",
      redirect: { name: 'ShoppingCart' },
      component: Shop,
    },
    {
      meta: {
        displayNameKey: "text.shopping_cart",
      },
      name: "ShoppingCart",
      path: "shop/cart",
      component: ShoppingCart,
    },

    //more ------------------------------------------------------------
    {
      meta: {
        displayNameKey: "text.company",
      },
      name: "Organization",
      path: "organization",
      component: Organization,
    },
  ],
};

export default routes;
